import React from 'react';

const OrderItems = ({items}) => {
    if (!items?.length) {
        return <p className="text-sm text-bark-500">Нет позиций</p>;
    }
    return (
        <div className="overflow-hidden rounded-2xl border border-stone-300/90 bg-white shadow-sm">
            <div className="hidden sm:grid sm:grid-cols-[1fr_auto_auto] sm:gap-4 sm:bg-pine-900 sm:px-4 sm:py-3">
                <span className="text-xs font-semibold uppercase tracking-wide text-cream-100">Товар</span>
                <span className="text-center text-xs font-semibold uppercase tracking-wide text-cream-100">Кол-во</span>
                <span className="text-right text-xs font-semibold uppercase tracking-wide text-cream-100">Сумма</span>
            </div>
            <ul className="divide-y divide-stone-200">
                {items.map((item, i) => (
                    <li
                        key={item.id}
                        className={`px-4 py-4 sm:grid sm:grid-cols-[1fr_auto_auto] sm:items-center sm:gap-4 sm:py-3 ${
                            i % 2 === 0 ? 'bg-cream-50/90' : 'bg-white'
                        }`}
                    >
                        <div className="min-w-0">
                            <p className="text-[13px] font-semibold leading-snug text-bark-900 sm:text-sm">{item.title}</p>
                            <p className="mt-0.5 text-xs text-bark-500 sm:hidden">
                                {item.itemCount} шт × {Number(item.price).toFixed(2)} ₽
                            </p>
                        </div>
                        <p className="mt-2 text-center text-sm tabular-nums text-bark-800 sm:mt-0 sm:text-base">
                            <span className="sm:hidden">× </span>
                            {item.itemCount}
                        </p>
                        <p className="mt-1 text-right text-base font-semibold tabular-nums text-bark-900 sm:mt-0 sm:text-lg">
                            {(item.itemCount * item.price).toFixed(2)} ₽
                        </p>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default OrderItems;
